import { useFileUpload } from "use-file-upload";
import { documentService } from "../../services";
import { IDocument } from "../../customTypings/document/Document";
import { IFolder } from "../../customTypings/document/Folder";

export const useDocumentActions = (
  currentFolder: IFolder | undefined,
  baseFolder: boolean,
  taskId: string | undefined,
  refresh: () => void,
  setAlertMessage: (message: string) => void,
  setRemoveActionActive: (active: boolean) => void
) => {
  const [_, selectFiles] = useFileUpload();

  const handleFileSelect = () => {
    if (currentFolder && (baseFolder || taskId)) {
      selectFiles({ accept: "", multiple: true }, (response) => {
        const files = (response as any[]).map((f) => f.file);

        documentService
          .uploadFile(currentFolder?.id, files, taskId as string)
          .then(() => {
            refresh();
          })
          .catch((rejected) => {
            setAlertMessage("Could not upload file: " + rejected);
          });
      });
    }
  };

  const handleDownloadDocument = (document: IDocument) => {
    window.open(
      "/api/document/download/" + document.id,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const handleRemoveDocument = (document: IDocument) => {
    documentService
      .removeDocument(document.id)
      .then(() => {
        refresh();
        setRemoveActionActive(false);
      })
      .catch((rejected) => {
        setAlertMessage("Could not remove file: " + rejected);
      });
  };

  const handleRemoveFolder = (folder: IFolder) => {
    documentService
      .removeFolder(folder.id)
      .then(() => {
        refresh();
        setRemoveActionActive(false);
      })
      .catch((rejected) => {
        setAlertMessage("Could not remove folder: " + rejected);
      });
  };

  const handleFolderAdded = (added: boolean, setShowAddFolder: (show: boolean) => void) => {
    setShowAddFolder(false);
    refresh();
  };

  return {
    handleFileSelect,
    handleDownloadDocument,
    handleRemoveDocument,
    handleRemoveFolder,
    handleFolderAdded,
  };
};
